import moment from "moment-timezone";
export const Moment = (a, b) => {
  if (!a) return "-";
  let time = a.toString().length === 10 ? new Date(a * 1000) : new Date(a * 1);
  let format = b ? b : "DD-MM-YYYY HH:mm:ss";
  return moment(time)
    .tz("Asia/Jakarta")
    .format(format);
};

export const isWorking = () => {
  let h =
    moment()
      .tz("Asia/Jakarta")
      .format("H") * 1;
  let week =
    moment()
      .tz("Asia/Jakarta")
      .format("d") * 1;
  if ((week < 6 && 8 < h < 19) || (week > 5 && 8 < h < 16)) {
    return true;
  } else {
    return false;
  }
};
export const rem = () => {
  getRem(750, 100);
};
window.onresize = function getRem() {
  rem();
};
export const getRem = (pwidth, prem) => {
  let html = document.getElementsByTagName("html")[0];
  let oWidth =
    document.body.clientWidth || document.documentElement.clientWidth;
  const pagePath = `${window.location.pathname || ""}${window.location.hash ||
    ""}`
    .split("?")[0]
    .toLowerCase();
  const isRegisterLandingPage = /\/(register|registerv2|registerfb|registertt)(\/|$)/.test(
    pagePath
  );
  const PC_MIN_WIDTH = 1080;
  const PC_FIXED_FONT_SIZE = "60px";

  if (isRegisterLandingPage && oWidth >= PC_MIN_WIDTH) {
    html.style.fontSize = PC_FIXED_FONT_SIZE;
    return;
  }

  html.style.fontSize = (oWidth / pwidth) * prem + "px";
};
export const phoneTest = phone => {
  var pattern = /^08\d{8,13}$/;
  return new Promise(resolve => {
    if (phone && phone.length > 0 && pattern.test(phone)) {
      resolve(true);
    } else {
      resolve(false);
    }
  });
};
export const NYR = (a, all) => {
  if (!a) return "-";
  let time = a.toString().length === 10 ? new Date(a * 1000) : new Date(a * 1);
  let year = time.getFullYear();
  let mounth =
    time.getMonth() + 1 > 9 ? time.getMonth() + 1 : "0" + (time.getMonth() + 1);
  let day = time.getDate() > 9 ? time.getDate() : "0" + time.getDate();
  let hour = time.getHours() > 9 ? time.getHours() : "0" + time.getHours();
  let minutes =
    time.getMinutes() > 9 ? time.getMinutes() : "0" + time.getMinutes();
  let seconds =
    time.getSeconds() > 9 ? time.getSeconds() : "0" + time.getSeconds();
  if (all) {
    return `${day}-${mounth}-${year} ${hour}:${minutes}:${seconds}`;
  } else {
    return `${day}-${mounth}-${year}`;
  }
};
export const money = (number, decimals, dec_point, thousands_sep) => {
  number = (number + "").replace(/[^0-9+-Ee.]/g, "");
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = typeof thousands_sep === "undefined" ? "." : thousands_sep,
    dec = typeof dec_point === "undefined" ? "." : dec_point,
    s = "",
    toFixedFix = function(n, prec) {
      var k = Math.pow(10, prec);
      return "" + Math.floor(n * k) / k;
    };

  s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
  var re = /(-?\d+)(\d{3})/;
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, "$1" + sep + "$2");
  }

  if ((s[1] || "").length < prec) {
    s[1] = s[1] || "";
    s[1] += new Array(prec - s[1].length + 1).join("0");
  }
  return s.join(dec);
};
export const isRepayDay = (str1, str2) => {
  let time1 =
    str1.toString().length === 10 ? new Date(str1 * 1000) : new Date(str1 * 1);
  let all1 = moment(time1)
    .tz("Asia/Jakarta")
    .format("DD-MM-YYYY");

  let time2 =
    str2.toString().length === 10 ? new Date(str2 * 1000) : new Date(str2 * 1);
  let all2 = moment(time2)
    .tz("Asia/Jakarta")
    .format("DD-MM-YYYY");
  return all1 === all2;
};
export function rewriteLog() {
  console.log = (function(log) {
    return process.env.VUE_APP_FLAG === "development" ||
      process.env.VUE_APP_FLAG === "test"
      ? log
      : function() {};
  })(console.log);
}
export function countDown(year, mounth, day, hour, minute, second) {
  let now = new Date();
  let now_timestamp = Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate(),
    now.getUTCHours(),
    now.getUTCMinutes(),
    now.getUTCSeconds(),
    now.getUTCMilliseconds()
  );
  let arrive_timestamp = Date.UTC(
    year,
    mounth - 1,
    day,
    hour - 7,
    minute,
    second
  );
  let cha = arrive_timestamp - now_timestamp;
  let hour_1 = 1000 * 60 * 60;
  let minute_1 = 1000 * 60;
  let hours = Math.floor(cha / hour_1);
  let minutes = Math.floor((cha - hours * hour_1) / minute_1);
  let seconds = Math.floor((cha - hours * hour_1 - minutes * minute_1) / 1000);
  return {
    arrive: arrive_timestamp < now_timestamp,
    hours: hours < 10 ? `0${hours}` : `${hours}`,
    minutes: minutes < 10 ? `0${minutes}` : `${minutes}`,
    seconds: seconds < 10 ? `0${seconds}` : `${seconds}`
  };
}
export function isBegain(year, mounth, day, hour, minute, second) {
  let now = new Date();
  let now_timestamp = Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate(),
    now.getUTCHours(),
    now.getUTCMinutes(),
    now.getUTCSeconds(),
    now.getUTCMilliseconds()
  );
  let begain_timestamp = Date.UTC(
    year,
    mounth - 1,
    day,
    hour - 7,
    minute,
    second
  );
  return now_timestamp >= begain_timestamp;
}
